/**
 * What the cms has published for this market, as the index Galley rebuilds on every publish.
 *
 * A category or brand page asks for its cms file only when it has reason to think one exists:
 * the file is optional, and asking for thousands of files that are not there is a request per
 * page against a bucket that rate-limits. Until this existed the reason was a list in the
 * market's config - fifteen category permas and eight brands for Sweden - which meant a
 * storefront release for every banner somebody wanted to add. The index says the same thing
 * from the other side, where the content is.
 */
export type CmsIndex = {
	generatedAt: string;
	pages: string[];
	pieces: string[];
	brands: string[];
	categories: string[];
};

export type CmsFamily = keyof Omit<CmsIndex, 'generatedAt'>;

/**
 * Whether to ask the cms for `<family>/<slug>.json`.
 *
 * The index decides when the market has one. The config list is what decided before the
 * index existed and stays the answer until the market publishes one, so a market not yet
 * indexed loses nothing. Case-insensitive, because the lists were and a perma arrives from
 * the url in whatever case the visitor typed.
 */
export function hasCmsFile(
	index: CmsIndex | null | undefined,
	family: CmsFamily,
	slug: string,
	fallback: string[]
): boolean {
	const wanted = slug.toLowerCase();
	const known = index && Array.isArray(index[family]) ? index[family] : fallback;
	return known.some((s) => s.toLowerCase() === wanted);
}
